var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudShell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8 33.2L9.6 24L18.8 14.8L16 12L4 24L16 36L18.8 33.2ZM29.2 33.2L38.4 24L29.2 14.8L32 12L44 24L32 36L29.2 33.2Z",
    fill: "#8075F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudShell);
export default __webpack_public_path__ + "static/media/cloudShell.de99ee58af2c9d2929d9c4726f591a3f.svg";
export { ForwardRef as ReactComponent };